module.exports = __webpack_public_path__ + "static/img/consult.6953bb8a.png";